import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import {
  PRODUCT_MANUAL_RECOMMENDATION_ENTITY,
  PRODUCT_RECOMMENDATION_ENTITY,
  ProductRecommendationsState,
} from '../product-recommendations-state';

export type ProductRecommendationsReducers = ProductRecommendationsState;

export function getReducers(): ActionReducerMap<ProductRecommendationsReducers> {
  return {
    productRecommendation: StateUtils.loaderReducer(PRODUCT_RECOMMENDATION_ENTITY),
    productManualRecommendation: StateUtils.loaderReducer(PRODUCT_MANUAL_RECOMMENDATION_ENTITY),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<ProductRecommendationsReducers>> = new InjectionToken<
  ActionReducerMap<ProductRecommendationsReducers>
>('ProductRecommendationsReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
